import PropTypes from 'prop-types'
import { Close } from 'chaoskit/src/components'
import Modal from 'chaoskit/src/components/Modal'

export const ResponsiveVideo = ({
  width = 640,
  height = 360,
  src,
  title,
  autoplay,
  ...rest
}) => (
  <div
    css={{
      paddingBottom: `${(height / width) * 100}%`,
      marginBottom: 0,
      position: 'relative',
      height: 0,
      overflow: 'hidden',

      iframe: {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
      },
    }}
    {...rest}
  >
    <iframe title={title} src={src} allow={autoplay ? 'autoplay' : null} />
  </div>
)

ResponsiveVideo.propTypes = {
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  src: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  autoplay: PropTypes.bool,
}

export const VideoModal = ({ src, title, isOpen, setIsOpen, ...rest }) => (
  <Modal
    open={isOpen}
    setIsOpen={setIsOpen}
    className="u-contrast"
    size="large"
    css={{
      '.CK__Modal__Dialog': {
        background: 'transparent',
        borderRadius: 0,
      },
    }}
    {...rest}
  >
    <Close onClick={() => setIsOpen(false)} />
    <ResponsiveVideo src={src} title={title} autoplay />
  </Modal>
)

VideoModal.propTypes = {
  isOpen: PropTypes.bool,
  setIsOpen: PropTypes.func.isRequired,
  src: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
}
